import { createI18n } from "vue-i18n";
import en from "./locales/en";
import ru from "./locales/ru";

const messages = { en, ru };
const supported = ["en", "ru"];

const browserLang = navigator.language.split("-")[0];
const saved = localStorage.getItem("locale");

const locale = saved || (supported.includes(browserLang) ? browserLang : "en");

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: "en",
  messages,
});
